import type BidOption from '../../../types/upgrades/bidUpgrade/BidOption';
import type { ShoppingCartItem } from '../../../types/shoppingCart/ShoppingCart';
import type { TokenSegment } from '../../libs/utils/experience/useTokenDataQuery';
import findCashPurchaseOption from '../../libs/utils/shoppingCart/findCashPurchaseOption';
import useExperience from '../experience/useExperience';
import useConvertVariantToShoppingCartItem from './useConvertVariantToShoppingCartItem';

/**
 * @deprecated This function is only used by Cruise
 */
const useConvertBidOptionToCartItem = () => {
  const { experience } = useExperience().states;

  const { convertVariantToShoppingCartItem } = useConvertVariantToShoppingCartItem().actions;

  const convertBidOptionToCardItem = (
    bidOption: BidOption,
    equipmentInfo: TokenSegment | undefined,
    amount: number,
  ): ShoppingCartItem => {
    const { variant, product } =
      experience?.purchasableTrips
        .flatMap((trip) => trip.steps)
        .flatMap((step) => step.products)
        .flatMap((product) =>
          product.variants.map((variant) => {
            return { product, variant };
          }),
        )
        .find(({ variant }) => variant.encryptedId === bidOption.encryptedId) ?? {};

    if (variant === undefined || experience === undefined) {
      throw new Error('impossible to convert bid option to cart item');
    }

    // deep copy to not be readonly
    const purchaseOption = JSON.parse(JSON.stringify(findCashPurchaseOption(variant)));
    // update the paymentBreakdown to have the latest amount otherwise it stays as the original amount
    purchaseOption.paymentBreakdown.amount = amount;
    purchaseOption.paymentBreakdown.baseAmount = amount;

    return {
      ...convertVariantToShoppingCartItem(variant, {
        amount,
        purchaseOption,
        currency: bidOption.currency,
        equipment: equipmentInfo?.equipment ?? '',
      }),
      quantity: bidOption.quantity,
      quantityType: bidOption.quantityType,
      fromCabin: equipmentInfo?.equipment ? `${equipmentInfo?.equipment}_${variant.fromCabin}` : variant.fromCabin,
      marketingProductNumber: product?.productDetails?.marketingProductNumber,
    };
  };

  return {
    actions: {
      convertBidOptionToCardItem,
    },
  };
};

export default useConvertBidOptionToCartItem;
